import { STATIC_URL } from '../config';

// 統一組合媒體（頭像/圖片/音訊/影片）URL：
// - path 為空時回傳 null，避免組出 `${STATIC_URL}undefined` 這種無意義請求
// - path 已是絕對網址時直接使用
export const mediaUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${STATIC_URL}${path}`;
};
